/** The lifecycle mark of a closed tenant (tenant retirement): an outlined chip with the stop icon and
 *  the word — "Closed", "Releasing code", "Code released", "Restoring" — beside the environment
 *  badge in the tour operators grid. Nothing for an active tenant (every tenant is active unless it
 *  says otherwise). A state, not an alarm: neutral, never colour alone. */
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
import { Chip, Tooltip } from '@mui/material';

import type { TenantLifecycle } from '@/api/tenantLifecycle';

import { LIFECYCLE_HELP, LIFECYCLE_LABEL, isClosedLifecycle } from './lifecycleWords';

export function LifecycleChip({
  lifecycle,
  size = 'small',
}: {
  lifecycle: TenantLifecycle | null | undefined;
  size?: 'small' | 'medium';
}) {
  if (!lifecycle || !isClosedLifecycle(lifecycle)) return null;
  return (
    <Tooltip describeChild title={LIFECYCLE_HELP[lifecycle]}>
      <Chip
        size={size}
        variant="outlined"
        icon={<DoNotDisturbOnOutlinedIcon />}
        label={LIFECYCLE_LABEL[lifecycle]}
        data-lifecycle={lifecycle}
        sx={{ flex: 'none' }}
      />
    </Tooltip>
  );
}
